import React from "react";
import {Route, Switch, useLocation} from "react-router-dom";
import VariantWidgetPage from "./Variant/VariantWidgetPage";
import OrderWidgetPage from "./Order/OrderWidgetPage";
import AutoCatalogWidgetPage from "./AutoCatalog/AutoCatalogWidgetPage";
import OrderPageWidgetPage from "./OrderPage/OrderPageWidgetPage";
import PrintLabelsWidgetPage from "./PrintLabels/PrintLabelsWidgetPage";
import ErrorPortal from "../Components/ErrorPortal/ErrorPortal";

export const routeName = "widgets";

function WidgetsRouter() {
    const query = new URLSearchParams(useLocation().search);
    const contextKey = query.get("contextKey");
    if (!contextKey) {
        return <></>;
    }

    // без портала ошибки от бэкенда в попапе не показать: он монтируется только в остальных роутерах
    return <>
        <ErrorPortal/>
        <Switch>
        <Route path={`/${routeName}/orderpage`}>
            <div style={{height: '100vh'}}>
                <OrderPageWidgetPage contextKey={contextKey}/>
            </div>
        </Route>
        <Route path={`/${routeName}/variant`}>
            <div style={{backgroundColor: '#f7f7f7', height: '100vh'}}>
                <VariantWidgetPage contextKey={contextKey}/>
            </div>
        </Route>
        <Route path={`/${routeName}/order`}>
            <div style={{backgroundColor: '#f7f7f7', height: '100vh'}}>
                <OrderWidgetPage contextKey={contextKey}/>
            </div>
        </Route>
        <Route path={`/${routeName}/printlabels`}>
            <div style={{height: '100vh'}}>
                <PrintLabelsWidgetPage contextKey={contextKey}/>
            </div>
        </Route>
        <Route path={`/${routeName}/autocatalog`}>
            <div style={{height: '100vh'}}>
                <AutoCatalogWidgetPage contextKey={contextKey}/>
            </div>
        </Route>
        </Switch>
    </>
}

export default WidgetsRouter;